import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
export const CommonModuleNgFactory:i0.NgModuleFactory<i1.CommonModule> = (null as any);
var _decl0_0:i1.NgClass = (<any>(null as any));
var _decl0_1:i1.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i1.NgForOf<any> = (<any>(null as any));
var _decl0_3:i1.NgIf = (<any>(null as any));
var _decl0_4:i1.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i1.NgStyle = (<any>(null as any));
var _decl0_6:i1.NgSwitch = (<any>(null as any));
var _decl0_7:i1.NgSwitchCase = (<any>(null as any));
var _decl0_8:i1.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i1.NgPlural = (<any>(null as any));
var _decl0_10:i1.NgPluralCase = (<any>(null as any));
var _decl0_12:i1.AsyncPipe = (<any>(null as any));
var _decl0_14:i1.UpperCasePipe = (<any>(null as any));
var _decl0_16:i1.LowerCasePipe = (<any>(null as any));
var _decl0_18:i1.JsonPipe = (<any>(null as any));
var _decl0_20:i1.SlicePipe = (<any>(null as any));
var _decl0_22:i1.DecimalPipe = (<any>(null as any));
var _decl0_24:i1.PercentPipe = (<any>(null as any));
var _decl0_26:i1.TitleCasePipe = (<any>(null as any));
var _decl0_28:i1.CurrencyPipe = (<any>(null as any));
var _decl0_30:i1.DatePipe = (<any>(null as any));
var _decl0_32:i1.I18nPluralPipe = (<any>(null as any));
var _decl0_34:i1.I18nSelectPipe = (<any>(null as any));
var _decl0_35:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_36:i0.ElementRef = (<any>(null as any));
export const DeprecatedI18NPipesModuleNgFactory:i0.NgModuleFactory<i1.DeprecatedI18NPipesModule> = (null as any);
var _decl1_1:i1.DeprecatedDecimalPipe = (<any>(null as any));
var _decl1_3:i1.DeprecatedPercentPipe = (<any>(null as any));
var _decl1_5:i1.DeprecatedCurrencyPipe = (<any>(null as any));
var _decl1_7:i1.DeprecatedDatePipe = (<any>(null as any));
var _decl1_8:i0.TemplateRef<any> = (<any>(null as any));
var _decl1_9:i0.ElementRef = (<any>(null as any));
